module.exports = __webpack_public_path__ + "36d7c7c7-37f6-4684-9be8-7a1dd418e06c.0466b3ac589ab3855458.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/assets/fonts/36d7c7c7-37f6-4684-9be8-7a1dd418e06c.woff2
// module id = ../../../../../src/assets/fonts/36d7c7c7-37f6-4684-9be8-7a1dd418e06c.woff2
// module chunks = 2